module.exports = __webpack_public_path__ + "img/photo-06.a5ee95fb.png";